import { useEffect, useRef, useState } from 'react'

export const useIsTruncated = <T extends HTMLElement>() => {
  const elementReference = useRef<T>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const element = elementReference.current
    if (!element) return

    const checkTruncation = () => {
      setIsTruncated(element.scrollWidth > element.clientWidth)
    }

    checkTruncation()
    element.addEventListener('mouseenter', checkTruncation)

    const resizeObserver = new ResizeObserver(checkTruncation)
    resizeObserver.observe(element)

    return () => {
      element.removeEventListener('mouseenter', checkTruncation)
      resizeObserver.disconnect()
    }
  }, [])

  return {
    isTruncated,
    elementReference,
  }
}
